import React from "react";
import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Home from "./components/Pages/Home/home";
import ScrollToTop from "./utiles/ScrollToTop";
import AimAndScope from "./components/Pages/AimAndScope/AimAndScope";
import AuthorsGuideline from "./components/Pages/AuthorsGuidelines/AuthorsGuideline/AuthorsGuideline";
import Topics from "./components/Pages/AuthorsGuidelines/Topics/Topics";
import ProcessingFees from "./components/Pages/AuthorsGuidelines/ProcessingFees/ProcessingFees";

import MainLayout from "./components/Layouts/MainLayout/MainLayout";
import SeconderyLayout from "./components/Layouts/SeconderyLayout/SeconderyLayout";

import OnlineSubmission from "./components/Pages/OnlineSubmission/OnlineSubmission";
import Volumes from "./components/Pages/HistoricalRepository/Volumes";
import Reviewers from "./components/Pages/EditorialPanel/reviewers/reviewers";
import JoinAsReviewer from "./components/Pages/EditorialPanel/JoinAsReviewer/JoinAsReviewer";
import ContactUs from "./components/Pages/ContactUs/ContactUs";

import PrivacyPolicy from "./components/Pages/Policies/PrivacyPolicy";
import UsagePolicy from "./components/Pages/Policies/UsagePolicy";
import WebsitePolicies from "./components/Pages/Policies/WebsitePolicies";
import ContentPolicy from "./components/Pages/Policies/ContentPolicy";

import ScrollToTopButton from "./utiles/ScrollToTopButton/ScrollToTopButton";

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="app-container">
        <Routes>
          <Route path="/" element={<Home />} />


      {/* Main Layout Routes */}

          <Route
            path="/AimAndScope" element={<MainLayout><AimAndScope /></MainLayout>}
          />
          <Route
            path="/AuthorsGuideline"element={<MainLayout><AuthorsGuideline /></MainLayout>}
          />
          <Route
            path="/Topics" element={<MainLayout><Topics /></MainLayout>}
          />
          <Route
            path="/Reviewers" element={<MainLayout><Reviewers /></MainLayout>}
          />



      {/* Secondery Layout Routes */}

          <Route
            path="/Fees" element={<SeconderyLayout><ProcessingFees /></SeconderyLayout>}
          />
          <Route
            path="/OnlineSubmission" element={<SeconderyLayout><OnlineSubmission /></SeconderyLayout>}
          />
          <Route
            path="/Volumes" element={<SeconderyLayout><Volumes /></SeconderyLayout>}
          />
          <Route
            path="/JoinAsReviewer" element={<SeconderyLayout><JoinAsReviewer /></SeconderyLayout>}
          />
          <Route
            path="/ContactUs"element={ <MainLayout><ContactUs /></MainLayout> }
          />

          <Route
            path="/policies"element={ <SeconderyLayout><WebsitePolicies /></SeconderyLayout> }
          />
          <Route
            path="/usage-policy"element={ <SeconderyLayout><UsagePolicy /></SeconderyLayout> }
          />
          <Route
            path="/content-policy"element={ <SeconderyLayout><ContentPolicy /></SeconderyLayout> }
          />
          <Route
            path="/privacy-policy"element={ <SeconderyLayout><PrivacyPolicy /></SeconderyLayout> }
          />

        </Routes>
      </div>
       <ScrollToTopButton />
    </Router>
  );
}

export default App;
